import React from 'react'

const PlaqueRecordUX = (props) => {
  return(
  <svg id="svg-dr" height="270" width="1200">
  <text 
    x={150}
    y={65}
    textAnchor="middle" 
    stroke="#FFFFFF" 
    strokeWidth="0.1px" 
    dy=".3em"
    fontWeight="bold"
    fontSize="1.5em"
    fill="black" >Plaque record</text>
  
    <polygon
      points="550,30 570,10 530,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P111") ? "#ffff14" : "white"}
      transform="rotate(0 550 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P111"}})}}
      {...props.settings?.P111}
    />
    <polygon
      points="550,30 570,10 530,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P112") ? "#ffff14" : "white"}
      transform="rotate(-90 550 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P112"}})}}
      {...props.settings?.P112}
    />
    <polygon
      points="550,30 570,10 530,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P113") ? "#ffff14" : "white"}
      transform="rotate(-180 550 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P113"}})}}
      {...props.settings?.P113}
    />
    <polygon
      points="550,30 570,10 530,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P114") ? "#ffff14" : "white"}
      transform="rotate(-270 550 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P114"}})}}
      {...props.settings?.P114}
    />
      <text 
        x={550}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >1</text>
      
    <polygon
      points="510,30 530,10 490,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P121") ? "#ffff14" : "white"}
      transform="rotate(0 510 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P121"}})}}
      {...props.settings?.P121}
    />
    <polygon
      points="510,30 530,10 490,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P122") ? "#ffff14" : "white"}
      transform="rotate(-90 510 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P122"}})}}
      {...props.settings?.P122}
    />
    <polygon
      points="510,30 530,10 490,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P123") ? "#ffff14" : "white"}
      transform="rotate(-180 510 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P123"}})}}
      {...props.settings?.P123}
    />
    <polygon
      points="510,30 530,10 490,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P124") ? "#ffff14" : "white"}
      transform="rotate(-270 510 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P124"}})}}
      {...props.settings?.P124}
    />
      <text 
        x={510}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >2</text>
      
    <polygon
      points="470,30 490,10 450,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P131") ? "#ffff14" : "white"}
      transform="rotate(0 470 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P131"}})}}
      {...props.settings?.P131}
    />
    <polygon
      points="470,30 490,10 450,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P132") ? "#ffff14" : "white"}
      transform="rotate(-90 470 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P132"}})}}
      {...props.settings?.P132}
    />
    <polygon
      points="470,30 490,10 450,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P133") ? "#ffff14" : "white"}
      transform="rotate(-180 470 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P133"}})}}
      {...props.settings?.P133}
    />
    <polygon
      points="470,30 490,10 450,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P134") ? "#ffff14" : "white"}
      transform="rotate(-270 470 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P134"}})}}
      {...props.settings?.P134}
    />
      <text 
        x={470}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >3</text>
      
    <polygon
      points="430,30 450,10 410,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P141") ? "#ffff14" : "white"}
      transform="rotate(0 430 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P141"}})}}
      {...props.settings?.P141}
    />
    <polygon
      points="430,30 450,10 410,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P142") ? "#ffff14" : "white"}
      transform="rotate(-90 430 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P142"}})}}
      {...props.settings?.P142}
    />
    <polygon
      points="430,30 450,10 410,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P143") ? "#ffff14" : "white"}
      transform="rotate(-180 430 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P143"}})}}
      {...props.settings?.P143}
    />
    <polygon
      points="430,30 450,10 410,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P144") ? "#ffff14" : "white"}
      transform="rotate(-270 430 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P144"}})}}
      {...props.settings?.P144}
    />
      <text 
        x={430}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >4</text>
      
    <polygon
      points="390,30 410,10 370,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P151") ? "#ffff14" : "white"}
      transform="rotate(0 390 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P151"}})}}
      {...props.settings?.P151}
    />
    <polygon
      points="390,30 410,10 370,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P152") ? "#ffff14" : "white"}
      transform="rotate(-90 390 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P152"}})}}
      {...props.settings?.P152}
    />
    <polygon
      points="390,30 410,10 370,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P153") ? "#ffff14" : "white"}
      transform="rotate(-180 390 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P153"}})}}
      {...props.settings?.P153}
    />
    <polygon
      points="390,30 410,10 370,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P154") ? "#ffff14" : "white"}
      transform="rotate(-270 390 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P154"}})}}
      {...props.settings?.P154}
    />
      <text 
        x={390}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >5</text>
      
    <polygon
      points="350,30 370,10 330,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P161") ? "#ffff14" : "white"}
      transform="rotate(0 350 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P161"}})}}
      {...props.settings?.P161}
    />
    <polygon
      points="350,30 370,10 330,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P162") ? "#ffff14" : "white"}
      transform="rotate(-90 350 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P162"}})}}
      {...props.settings?.P162}
    />
    <polygon
      points="350,30 370,10 330,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P163") ? "#ffff14" : "white"}
      transform="rotate(-180 350 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P163"}})}}
      {...props.settings?.P163}
    />
    <polygon
      points="350,30 370,10 330,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P164") ? "#ffff14" : "white"}
      transform="rotate(-270 350 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P164"}})}}
      {...props.settings?.P164}
    />
      <text 
        x={350}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >6</text>
      
    <polygon
      points="310,30 330,10 290,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P171") ? "#ffff14" : "white"}
      transform="rotate(0 310 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P171"}})}}
      {...props.settings?.P171}
    />
    <polygon
      points="310,30 330,10 290,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P172") ? "#ffff14" : "white"}
      transform="rotate(-90 310 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P172"}})}}
      {...props.settings?.P172}
    />
    <polygon
      points="310,30 330,10 290,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P173") ? "#ffff14" : "white"}
      transform="rotate(-180 310 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P173"}})}}
      {...props.settings?.P173}
    />
    <polygon
      points="310,30 330,10 290,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P174") ? "#ffff14" : "white"}
      transform="rotate(-270 310 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P174"}})}}
      {...props.settings?.P174}
    />
      <text 
        x={310}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >7</text>
      
    <polygon
      points="270,30 290,10 250,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P181") ? "#ffff14" : "white"}
      transform="rotate(0 270 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P181"}})}}
      {...props.settings?.P181}
    />
    <polygon
      points="270,30 290,10 250,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P182") ? "#ffff14" : "white"}
      transform="rotate(-90 270 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P182"}})}}
      {...props.settings?.P182}
    />
    <polygon
      points="270,30 290,10 250,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P183") ? "#ffff14" : "white"}
      transform="rotate(-180 270 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P183"}})}}
      {...props.settings?.P183}
    />
    <polygon
      points="270,30 290,10 250,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P184") ? "#ffff14" : "white"}
      transform="rotate(-270 270 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P184"}})}}
      {...props.settings?.P184}
    />
      <text 
        x={270}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >8</text>
      
    <polygon
      points="645,30 665,10 625,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P211") ? "#ffff14" : "white"}
      transform="rotate(0 645 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P211"}})}}
      {...props.settings?.P211}
    />
    <polygon
      points="645,30 665,10 625,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P212") ? "#ffff14" : "white"}
      transform="rotate(-90 645 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P212"}})}}
      {...props.settings?.P212}
    />
    <polygon
      points="645,30 665,10 625,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P213") ? "#ffff14" : "white"}
      transform="rotate(-180 645 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P213"}})}}
      {...props.settings?.P213}
    />
    <polygon
      points="645,30 665,10 625,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P214") ? "#ffff14" : "white"}
      transform="rotate(-270 645 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P214"}})}}
      {...props.settings?.P214}
    />
      <text 
        x={645}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >1</text>
      <>
      <text 
        x={597.5}
        y={6}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >Buccal</text>
      <text 
        x={597.5}
        y={54}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >Lingual</text>
      </>
      
    <polygon
      points="685,30 705,10 665,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P221") ? "#ffff14" : "white"}
      transform="rotate(0 685 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P221"}})}}
      {...props.settings?.P221}
    />
    <polygon
      points="685,30 705,10 665,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P222") ? "#ffff14" : "white"}
      transform="rotate(-90 685 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P222"}})}}
      {...props.settings?.P222}
    />
    <polygon
      points="685,30 705,10 665,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P223") ? "#ffff14" : "white"}
      transform="rotate(-180 685 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P223"}})}}
      {...props.settings?.P223}
    />
    <polygon
      points="685,30 705,10 665,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P224") ? "#ffff14" : "white"}
      transform="rotate(-270 685 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P224"}})}}
      {...props.settings?.P224}
    />
      <text 
        x={685}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >2</text>
      
    <polygon
      points="725,30 745,10 705,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P231") ? "#ffff14" : "white"}
      transform="rotate(0 725 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P231"}})}}
      {...props.settings?.P231}
    />
    <polygon
      points="725,30 745,10 705,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P232") ? "#ffff14" : "white"}
      transform="rotate(-90 725 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P232"}})}}
      {...props.settings?.P232}
    />
    <polygon
      points="725,30 745,10 705,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P233") ? "#ffff14" : "white"}
      transform="rotate(-180 725 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P233"}})}}
      {...props.settings?.P233}
    />
    <polygon
      points="725,30 745,10 705,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P234") ? "#ffff14" : "white"}
      transform="rotate(-270 725 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P234"}})}}
      {...props.settings?.P234}
    />
      <text 
        x={725}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >3</text>
      
    <polygon
      points="765,30 785,10 745,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P241") ? "#ffff14" : "white"}
      transform="rotate(0 765 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P241"}})}}
      {...props.settings?.P241}
    />
    <polygon
      points="765,30 785,10 745,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P242") ? "#ffff14" : "white"}
      transform="rotate(-90 765 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P242"}})}}
      {...props.settings?.P242}
    />
    <polygon
      points="765,30 785,10 745,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P243") ? "#ffff14" : "white"}
      transform="rotate(-180 765 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P243"}})}}
      {...props.settings?.P243}
    />
    <polygon
      points="765,30 785,10 745,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P244") ? "#ffff14" : "white"}
      transform="rotate(-270 765 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P244"}})}}
      {...props.settings?.P244}
    />
      <text 
        x={765}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >4</text>
      
    <polygon
      points="805,30 825,10 785,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P251") ? "#ffff14" : "white"}
      transform="rotate(0 805 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P251"}})}}
      {...props.settings?.P251}
    />
    <polygon
      points="805,30 825,10 785,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P252") ? "#ffff14" : "white"}
      transform="rotate(-90 805 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P252"}})}}
      {...props.settings?.P252}
    />
    <polygon
      points="805,30 825,10 785,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P253") ? "#ffff14" : "white"}
      transform="rotate(-180 805 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P253"}})}}
      {...props.settings?.P253}
    />
    <polygon
      points="805,30 825,10 785,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P254") ? "#ffff14" : "white"}
      transform="rotate(-270 805 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P254"}})}}
      {...props.settings?.P254}
    />
      <text 
        x={805}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >5</text>
      
    <polygon
      points="845,30 865,10 825,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P261") ? "#ffff14" : "white"}
      transform="rotate(0 845 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P261"}})}}
      {...props.settings?.P261}
    />
    <polygon
      points="845,30 865,10 825,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P262") ? "#ffff14" : "white"}
      transform="rotate(-90 845 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P262"}})}}
      {...props.settings?.P262}
    />
    <polygon
      points="845,30 865,10 825,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P263") ? "#ffff14" : "white"}
      transform="rotate(-180 845 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P263"}})}}
      {...props.settings?.P263}
    />
    <polygon
      points="845,30 865,10 825,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P264") ? "#ffff14" : "white"}
      transform="rotate(-270 845 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P264"}})}}
      {...props.settings?.P264}
    />
      <text 
        x={845}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >6</text>
      
    <polygon
      points="885,30 905,10 865,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P271") ? "#ffff14" : "white"}
      transform="rotate(0 885 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P271"}})}}
      {...props.settings?.P271}
    />
    <polygon
      points="885,30 905,10 865,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P272") ? "#ffff14" : "white"}
      transform="rotate(-90 885 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P272"}})}}
      {...props.settings?.P272}
    />
    <polygon
      points="885,30 905,10 865,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P273") ? "#ffff14" : "white"}
      transform="rotate(-180 885 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P273"}})}}
      {...props.settings?.P273}
    />
    <polygon
      points="885,30 905,10 865,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P274") ? "#ffff14" : "white"}
      transform="rotate(-270 885 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P274"}})}}
      {...props.settings?.P274}
    />
      <text 
        x={885}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >7</text>
      
    <polygon
      points="925,30 945,10 905,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P281") ? "#ffff14" : "white"}
      transform="rotate(0 925 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P281"}})}}
      {...props.settings?.P281}
    />
    <polygon
      points="925,30 945,10 905,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P282") ? "#ffff14" : "white"}
      transform="rotate(-90 925 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P282"}})}}
      {...props.settings?.P282}
    />
    <polygon
      points="925,30 945,10 905,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P283") ? "#ffff14" : "white"}
      transform="rotate(-180 925 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P283"}})}}
      {...props.settings?.P283}
    />
    <polygon
      points="925,30 945,10 905,10"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P284") ? "#ffff14" : "white"}
      transform="rotate(-270 925 30)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P284"}})}}
      {...props.settings?.P284}
    />
      <text 
        x={925}
        y={66}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >8</text>
      
    <polygon
      points="645,100 665,80 625,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P311") ? "#ffff14" : "white"}
      transform="rotate(0 645 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P311"}})}}
      {...props.settings?.P311}
    />
    <polygon
      points="645,100 665,80 625,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P312") ? "#ffff14" : "white"}
      transform="rotate(-90 645 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P312"}})}}
      {...props.settings?.P312}
    />
    <polygon
      points="645,100 665,80 625,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P313") ? "#ffff14" : "white"}
      transform="rotate(-180 645 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P313"}})}}
      {...props.settings?.P313}
    />
    <polygon
      points="645,100 665,80 625,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P314") ? "#ffff14" : "white"}
      transform="rotate(-270 645 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P314"}})}}
      {...props.settings?.P314}
    /><>
      <text 
        x={597.5}
        y={76}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >Lingual</text>
      <text 
        x={597.5}
        y={124}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >Buccal</text>
      </>
      
    <polygon
      points="685,100 705,80 665,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P321") ? "#ffff14" : "white"}
      transform="rotate(0 685 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P321"}})}}
      {...props.settings?.P321}
    />
    <polygon
      points="685,100 705,80 665,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P322") ? "#ffff14" : "white"}
      transform="rotate(-90 685 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P322"}})}}
      {...props.settings?.P322}
    />
    <polygon
      points="685,100 705,80 665,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P323") ? "#ffff14" : "white"}
      transform="rotate(-180 685 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P323"}})}}
      {...props.settings?.P323}
    />
    <polygon
      points="685,100 705,80 665,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P324") ? "#ffff14" : "white"}
      transform="rotate(-270 685 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P324"}})}}
      {...props.settings?.P324}
    />
    <polygon
      points="725,100 745,80 705,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P331") ? "#ffff14" : "white"}
      transform="rotate(0 725 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P331"}})}}
      {...props.settings?.P331}
    />
    <polygon
      points="725,100 745,80 705,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P332") ? "#ffff14" : "white"}
      transform="rotate(-90 725 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P332"}})}}
      {...props.settings?.P332}
    />
    <polygon
      points="725,100 745,80 705,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P333") ? "#ffff14" : "white"}
      transform="rotate(-180 725 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P333"}})}}
      {...props.settings?.P333}
    />
    <polygon
      points="725,100 745,80 705,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P334") ? "#ffff14" : "white"}
      transform="rotate(-270 725 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P334"}})}}
      {...props.settings?.P334}
    />
    <polygon
      points="765,100 785,80 745,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P341") ? "#ffff14" : "white"}
      transform="rotate(0 765 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P341"}})}}
      {...props.settings?.P341}
    />
    <polygon
      points="765,100 785,80 745,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P342") ? "#ffff14" : "white"}
      transform="rotate(-90 765 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P342"}})}}
      {...props.settings?.P342}
    />
    <polygon
      points="765,100 785,80 745,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P343") ? "#ffff14" : "white"}
      transform="rotate(-180 765 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P343"}})}}
      {...props.settings?.P343}
    />
    <polygon
      points="765,100 785,80 745,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P344") ? "#ffff14" : "white"}
      transform="rotate(-270 765 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P344"}})}}
      {...props.settings?.P344}
    />
    <polygon
      points="805,100 825,80 785,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P351") ? "#ffff14" : "white"}
      transform="rotate(0 805 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P351"}})}}
      {...props.settings?.P351}
    />
    <polygon
      points="805,100 825,80 785,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P352") ? "#ffff14" : "white"}
      transform="rotate(-90 805 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P352"}})}}
      {...props.settings?.P352}
    />
    <polygon
      points="805,100 825,80 785,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P353") ? "#ffff14" : "white"}
      transform="rotate(-180 805 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P353"}})}}
      {...props.settings?.P353}
    />
    <polygon
      points="805,100 825,80 785,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P354") ? "#ffff14" : "white"}
      transform="rotate(-270 805 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P354"}})}}
      {...props.settings?.P354}
    />
    <polygon
      points="845,100 865,80 825,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P361") ? "#ffff14" : "white"}
      transform="rotate(0 845 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P361"}})}}
      {...props.settings?.P361}
    />
    <polygon
      points="845,100 865,80 825,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P362") ? "#ffff14" : "white"}
      transform="rotate(-90 845 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P362"}})}}
      {...props.settings?.P362}
    />
    <polygon
      points="845,100 865,80 825,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P363") ? "#ffff14" : "white"}
      transform="rotate(-180 845 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P363"}})}}
      {...props.settings?.P363}
    />
    <polygon
      points="845,100 865,80 825,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P364") ? "#ffff14" : "white"}
      transform="rotate(-270 845 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P364"}})}}
      {...props.settings?.P364}
    />
    <polygon
      points="885,100 905,80 865,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P371") ? "#ffff14" : "white"}
      transform="rotate(0 885 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P371"}})}}
      {...props.settings?.P371}
    />
    <polygon
      points="885,100 905,80 865,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P372") ? "#ffff14" : "white"}
      transform="rotate(-90 885 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P372"}})}}
      {...props.settings?.P372}
    />
    <polygon
      points="885,100 905,80 865,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P373") ? "#ffff14" : "white"}
      transform="rotate(-180 885 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P373"}})}}
      {...props.settings?.P373}
    />
    <polygon
      points="885,100 905,80 865,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P374") ? "#ffff14" : "white"}
      transform="rotate(-270 885 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P374"}})}}
      {...props.settings?.P374}
    />
    <polygon
      points="925,100 945,80 905,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P381") ? "#ffff14" : "white"}
      transform="rotate(0 925 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P381"}})}}
      {...props.settings?.P381}
    />
    <polygon
      points="925,100 945,80 905,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P382") ? "#ffff14" : "white"}
      transform="rotate(-90 925 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P382"}})}}
      {...props.settings?.P382}
    />
    <polygon
      points="925,100 945,80 905,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P383") ? "#ffff14" : "white"}
      transform="rotate(-180 925 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P383"}})}}
      {...props.settings?.P383}
    />
    <polygon
      points="925,100 945,80 905,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P384") ? "#ffff14" : "white"}
      transform="rotate(-270 925 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P384"}})}}
      {...props.settings?.P384}
    />
    <polygon
      points="550,100 570,80 530,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P411") ? "#ffff14" : "white"}
      transform="rotate(0 550 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P411"}})}}
      {...props.settings?.P411}
    />
    <polygon
      points="550,100 570,80 530,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P412") ? "#ffff14" : "white"}
      transform="rotate(-90 550 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P412"}})}}
      {...props.settings?.P412}
    />
    <polygon
      points="550,100 570,80 530,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P413") ? "#ffff14" : "white"}
      transform="rotate(-180 550 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P413"}})}}
      {...props.settings?.P413}
    />
    <polygon
      points="550,100 570,80 530,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P414") ? "#ffff14" : "white"}
      transform="rotate(-270 550 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P414"}})}}
      {...props.settings?.P414}
    />
    <polygon
      points="510,100 530,80 490,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P421") ? "#ffff14" : "white"}
      transform="rotate(0 510 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P421"}})}}
      {...props.settings?.P421}
    />
    <polygon
      points="510,100 530,80 490,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P422") ? "#ffff14" : "white"}
      transform="rotate(-90 510 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P422"}})}}
      {...props.settings?.P422}
    />
    <polygon
      points="510,100 530,80 490,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P423") ? "#ffff14" : "white"}
      transform="rotate(-180 510 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P423"}})}}
      {...props.settings?.P423}
    />
    <polygon
      points="510,100 530,80 490,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P424") ? "#ffff14" : "white"}
      transform="rotate(-270 510 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P424"}})}}
      {...props.settings?.P424}
    />
    <polygon
      points="470,100 490,80 450,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P431") ? "#ffff14" : "white"}
      transform="rotate(0 470 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P431"}})}}
      {...props.settings?.P431}
    />
    <polygon
      points="470,100 490,80 450,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P432") ? "#ffff14" : "white"}
      transform="rotate(-90 470 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P432"}})}}
      {...props.settings?.P432}
    />
    <polygon
      points="470,100 490,80 450,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P433") ? "#ffff14" : "white"}
      transform="rotate(-180 470 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P433"}})}}
      {...props.settings?.P433}
    />
    <polygon
      points="470,100 490,80 450,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P434") ? "#ffff14" : "white"}
      transform="rotate(-270 470 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P434"}})}}
      {...props.settings?.P434}
    />
    <polygon
      points="430,100 450,80 410,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P441") ? "#ffff14" : "white"}
      transform="rotate(0 430 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P441"}})}}
      {...props.settings?.P441}
    />
    <polygon
      points="430,100 450,80 410,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P442") ? "#ffff14" : "white"}
      transform="rotate(-90 430 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P442"}})}}
      {...props.settings?.P442}
    />
    <polygon
      points="430,100 450,80 410,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P443") ? "#ffff14" : "white"}
      transform="rotate(-180 430 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P443"}})}}
      {...props.settings?.P443}
    />
    <polygon
      points="430,100 450,80 410,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P444") ? "#ffff14" : "white"}
      transform="rotate(-270 430 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P444"}})}}
      {...props.settings?.P444}
    />
    <polygon
      points="390,100 410,80 370,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P451") ? "#ffff14" : "white"}
      transform="rotate(0 390 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P451"}})}}
      {...props.settings?.P451}
    />
    <polygon
      points="390,100 410,80 370,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P452") ? "#ffff14" : "white"}
      transform="rotate(-90 390 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P452"}})}}
      {...props.settings?.P452}
    />
    <polygon
      points="390,100 410,80 370,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P453") ? "#ffff14" : "white"}
      transform="rotate(-180 390 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P453"}})}}
      {...props.settings?.P453}
    />
    <polygon
      points="390,100 410,80 370,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P454") ? "#ffff14" : "white"}
      transform="rotate(-270 390 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P454"}})}}
      {...props.settings?.P454}
    />
    <polygon
      points="350,100 370,80 330,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P461") ? "#ffff14" : "white"}
      transform="rotate(0 350 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P461"}})}}
      {...props.settings?.P461}
    />
    <polygon
      points="350,100 370,80 330,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P462") ? "#ffff14" : "white"}
      transform="rotate(-90 350 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P462"}})}}
      {...props.settings?.P462}
    />
    <polygon
      points="350,100 370,80 330,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P463") ? "#ffff14" : "white"}
      transform="rotate(-180 350 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P463"}})}}
      {...props.settings?.P463}
    />
    <polygon
      points="350,100 370,80 330,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P464") ? "#ffff14" : "white"}
      transform="rotate(-270 350 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P464"}})}}
      {...props.settings?.P464}
    />
    <polygon
      points="310,100 330,80 290,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P471") ? "#ffff14" : "white"}
      transform="rotate(0 310 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P471"}})}}
      {...props.settings?.P471}
    />
    <polygon
      points="310,100 330,80 290,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P472") ? "#ffff14" : "white"}
      transform="rotate(-90 310 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P472"}})}}
      {...props.settings?.P472}
    />
    <polygon
      points="310,100 330,80 290,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P473") ? "#ffff14" : "white"}
      transform="rotate(-180 310 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P473"}})}}
      {...props.settings?.P473}
    />
    <polygon
      points="310,100 330,80 290,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P474") ? "#ffff14" : "white"}
      transform="rotate(-270 310 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P474"}})}}
      {...props.settings?.P474}
    />
    <polygon
      points="270,100 290,80 250,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P481") ? "#ffff14" : "white"}
      transform="rotate(0 270 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P481"}})}}
      {...props.settings?.P481}
    />
    <polygon
      points="270,100 290,80 250,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P482") ? "#ffff14" : "white"}
      transform="rotate(-90 270 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P482"}})}}
      {...props.settings?.P482}
    />
    <polygon
      points="270,100 290,80 250,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P483") ? "#ffff14" : "white"}
      transform="rotate(-180 270 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P483"}})}}
      {...props.settings?.P483}
    />
    <polygon
      points="270,100 290,80 250,80"
      stroke="black"
      fill={props.encounterInfo?.plaque?.includes("P484") ? "#ffff14" : "white"}
      transform="rotate(-270 270 100)"
      onClick={(e) => { props.onEvent({ message: "SetPlaque", params: { key: "P484"}})}}
      {...props.settings?.P484}
    />
  <text 
    x={150}
    y={205}
    textAnchor="middle" 
    stroke="#FFFFFF" 
    strokeWidth="0.1px" 
    dy=".3em"
    fontWeight="bold"
    fontSize="1.5em"
    fill="black" >Bleeding record</text>
  
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B111") ? "red" : "white"}
      d="M550,170 L550,150A20,20 0 0,0 532.6794919243113,160 L550,170"
      transform="rotate(30 550 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B111"}})}}
      {...props.settings?.B111}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B112") ? "red" : "white"}
      d="M550,170 L550,150A20,20 0 0,0 532.6794919243113,160 L550,170"
      transform="rotate(-30 550 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B112"}})}}
      {...props.settings?.B112}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B113") ? "red" : "white"}
      d="M550,170 L550,150A20,20 0 0,0 532.6794919243113,160 L550,170"
      transform="rotate(-90 550 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B113"}})}}
      {...props.settings?.B113}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B114") ? "red" : "white"}
      d="M550,170 L550,150A20,20 0 0,0 532.6794919243113,160 L550,170"
      transform="rotate(-150 550 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B114"}})}}
      {...props.settings?.B114}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B115") ? "red" : "white"}
      d="M550,170 L550,150A20,20 0 0,0 532.6794919243113,160 L550,170"
      transform="rotate(-210 550 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B115"}})}}
      {...props.settings?.B115}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B116") ? "red" : "white"}
      d="M550,170 L550,150A20,20 0 0,0 532.6794919243113,160 L550,170"
      transform="rotate(-270 550 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B116"}})}}
      {...props.settings?.B116}
    />
      <text 
        x={550}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >1</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B121") ? "red" : "white"}
      d="M510,170 L510,150A20,20 0 0,0 492.6794919243112,160 L510,170"
      transform="rotate(30 510 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B121"}})}}
      {...props.settings?.B121}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B122") ? "red" : "white"}
      d="M510,170 L510,150A20,20 0 0,0 492.6794919243112,160 L510,170"
      transform="rotate(-30 510 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B122"}})}}
      {...props.settings?.B122}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B123") ? "red" : "white"}
      d="M510,170 L510,150A20,20 0 0,0 492.6794919243112,160 L510,170"
      transform="rotate(-90 510 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B123"}})}}
      {...props.settings?.B123}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B124") ? "red" : "white"}
      d="M510,170 L510,150A20,20 0 0,0 492.6794919243112,160 L510,170"
      transform="rotate(-150 510 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B124"}})}}
      {...props.settings?.B124}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B125") ? "red" : "white"}
      d="M510,170 L510,150A20,20 0 0,0 492.6794919243112,160 L510,170"
      transform="rotate(-210 510 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B125"}})}}
      {...props.settings?.B125}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B126") ? "red" : "white"}
      d="M510,170 L510,150A20,20 0 0,0 492.6794919243112,160 L510,170"
      transform="rotate(-270 510 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B126"}})}}
      {...props.settings?.B126}
    />
      <text 
        x={510}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >2</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B131") ? "red" : "white"}
      d="M470,170 L470,150A20,20 0 0,0 452.6794919243112,160 L470,170"
      transform="rotate(30 470 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B131"}})}}
      {...props.settings?.B131}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B132") ? "red" : "white"}
      d="M470,170 L470,150A20,20 0 0,0 452.6794919243112,160 L470,170"
      transform="rotate(-30 470 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B132"}})}}
      {...props.settings?.B132}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B133") ? "red" : "white"}
      d="M470,170 L470,150A20,20 0 0,0 452.6794919243112,160 L470,170"
      transform="rotate(-90 470 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B133"}})}}
      {...props.settings?.B133}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B134") ? "red" : "white"}
      d="M470,170 L470,150A20,20 0 0,0 452.6794919243112,160 L470,170"
      transform="rotate(-150 470 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B134"}})}}
      {...props.settings?.B134}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B135") ? "red" : "white"}
      d="M470,170 L470,150A20,20 0 0,0 452.6794919243112,160 L470,170"
      transform="rotate(-210 470 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B135"}})}}
      {...props.settings?.B135}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B136") ? "red" : "white"}
      d="M470,170 L470,150A20,20 0 0,0 452.6794919243112,160 L470,170"
      transform="rotate(-270 470 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B136"}})}}
      {...props.settings?.B136}
    />
      <text 
        x={470}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >3</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B141") ? "red" : "white"}
      d="M430,170 L430,150A20,20 0 0,0 412.6794919243112,160 L430,170"
      transform="rotate(30 430 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B141"}})}}
      {...props.settings?.B141}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B142") ? "red" : "white"}
      d="M430,170 L430,150A20,20 0 0,0 412.6794919243112,160 L430,170"
      transform="rotate(-30 430 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B142"}})}}
      {...props.settings?.B142}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B143") ? "red" : "white"}
      d="M430,170 L430,150A20,20 0 0,0 412.6794919243112,160 L430,170"
      transform="rotate(-90 430 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B143"}})}}
      {...props.settings?.B143}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B144") ? "red" : "white"}
      d="M430,170 L430,150A20,20 0 0,0 412.6794919243112,160 L430,170"
      transform="rotate(-150 430 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B144"}})}}
      {...props.settings?.B144}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B145") ? "red" : "white"}
      d="M430,170 L430,150A20,20 0 0,0 412.6794919243112,160 L430,170"
      transform="rotate(-210 430 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B145"}})}}
      {...props.settings?.B145}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B146") ? "red" : "white"}
      d="M430,170 L430,150A20,20 0 0,0 412.6794919243112,160 L430,170"
      transform="rotate(-270 430 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B146"}})}}
      {...props.settings?.B146}
    />
      <text 
        x={430}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >4</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B151") ? "red" : "white"}
      d="M390,170 L390,150A20,20 0 0,0 372.6794919243112,160 L390,170"
      transform="rotate(30 390 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B151"}})}}
      {...props.settings?.B151}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B152") ? "red" : "white"}
      d="M390,170 L390,150A20,20 0 0,0 372.6794919243112,160 L390,170"
      transform="rotate(-30 390 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B152"}})}}
      {...props.settings?.B152}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B153") ? "red" : "white"}
      d="M390,170 L390,150A20,20 0 0,0 372.6794919243112,160 L390,170"
      transform="rotate(-90 390 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B153"}})}}
      {...props.settings?.B153}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B154") ? "red" : "white"}
      d="M390,170 L390,150A20,20 0 0,0 372.6794919243112,160 L390,170"
      transform="rotate(-150 390 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B154"}})}}
      {...props.settings?.B154}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B155") ? "red" : "white"}
      d="M390,170 L390,150A20,20 0 0,0 372.6794919243112,160 L390,170"
      transform="rotate(-210 390 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B155"}})}}
      {...props.settings?.B155}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B156") ? "red" : "white"}
      d="M390,170 L390,150A20,20 0 0,0 372.6794919243112,160 L390,170"
      transform="rotate(-270 390 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B156"}})}}
      {...props.settings?.B156}
    />
      <text 
        x={390}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >5</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B161") ? "red" : "white"}
      d="M350,170 L350,150A20,20 0 0,0 332.6794919243112,160 L350,170"
      transform="rotate(30 350 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B161"}})}}
      {...props.settings?.B161}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B162") ? "red" : "white"}
      d="M350,170 L350,150A20,20 0 0,0 332.6794919243112,160 L350,170"
      transform="rotate(-30 350 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B162"}})}}
      {...props.settings?.B162}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B163") ? "red" : "white"}
      d="M350,170 L350,150A20,20 0 0,0 332.6794919243112,160 L350,170"
      transform="rotate(-90 350 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B163"}})}}
      {...props.settings?.B163}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B164") ? "red" : "white"}
      d="M350,170 L350,150A20,20 0 0,0 332.6794919243112,160 L350,170"
      transform="rotate(-150 350 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B164"}})}}
      {...props.settings?.B164}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B165") ? "red" : "white"}
      d="M350,170 L350,150A20,20 0 0,0 332.6794919243112,160 L350,170"
      transform="rotate(-210 350 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B165"}})}}
      {...props.settings?.B165}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B166") ? "red" : "white"}
      d="M350,170 L350,150A20,20 0 0,0 332.6794919243112,160 L350,170"
      transform="rotate(-270 350 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B166"}})}}
      {...props.settings?.B166}
    />
      <text 
        x={350}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >6</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B171") ? "red" : "white"}
      d="M310,170 L310,150A20,20 0 0,0 292.6794919243112,160 L310,170"
      transform="rotate(30 310 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B171"}})}}
      {...props.settings?.B171}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B172") ? "red" : "white"}
      d="M310,170 L310,150A20,20 0 0,0 292.6794919243112,160 L310,170"
      transform="rotate(-30 310 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B172"}})}}
      {...props.settings?.B172}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B173") ? "red" : "white"}
      d="M310,170 L310,150A20,20 0 0,0 292.6794919243112,160 L310,170"
      transform="rotate(-90 310 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B173"}})}}
      {...props.settings?.B173}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B174") ? "red" : "white"}
      d="M310,170 L310,150A20,20 0 0,0 292.6794919243112,160 L310,170"
      transform="rotate(-150 310 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B174"}})}}
      {...props.settings?.B174}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B175") ? "red" : "white"}
      d="M310,170 L310,150A20,20 0 0,0 292.6794919243112,160 L310,170"
      transform="rotate(-210 310 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B175"}})}}
      {...props.settings?.B175}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B176") ? "red" : "white"}
      d="M310,170 L310,150A20,20 0 0,0 292.6794919243112,160 L310,170"
      transform="rotate(-270 310 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B176"}})}}
      {...props.settings?.B176}
    />
      <text 
        x={310}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >7</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B181") ? "red" : "white"}
      d="M270,170 L270,150A20,20 0 0,0 252.67949192431124,160 L270,170"
      transform="rotate(30 270 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B181"}})}}
      {...props.settings?.B181}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B182") ? "red" : "white"}
      d="M270,170 L270,150A20,20 0 0,0 252.67949192431124,160 L270,170"
      transform="rotate(-30 270 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B182"}})}}
      {...props.settings?.B182}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B183") ? "red" : "white"}
      d="M270,170 L270,150A20,20 0 0,0 252.67949192431124,160 L270,170"
      transform="rotate(-90 270 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B183"}})}}
      {...props.settings?.B183}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B184") ? "red" : "white"}
      d="M270,170 L270,150A20,20 0 0,0 252.67949192431124,160 L270,170"
      transform="rotate(-150 270 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B184"}})}}
      {...props.settings?.B184}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B185") ? "red" : "white"}
      d="M270,170 L270,150A20,20 0 0,0 252.67949192431124,160 L270,170"
      transform="rotate(-210 270 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B185"}})}}
      {...props.settings?.B185}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B186") ? "red" : "white"}
      d="M270,170 L270,150A20,20 0 0,0 252.67949192431124,160 L270,170"
      transform="rotate(-270 270 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B186"}})}}
      {...props.settings?.B186}
    />
      <text 
        x={270}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >8</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B211") ? "red" : "white"}
      d="M645,170 L645,150A20,20 0 0,0 627.6794919243113,160 L645,170"
      transform="rotate(30 645 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B211"}})}}
      {...props.settings?.B211}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B212") ? "red" : "white"}
      d="M645,170 L645,150A20,20 0 0,0 627.6794919243113,160 L645,170"
      transform="rotate(-30 645 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B212"}})}}
      {...props.settings?.B212}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B213") ? "red" : "white"}
      d="M645,170 L645,150A20,20 0 0,0 627.6794919243113,160 L645,170"
      transform="rotate(-90 645 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B213"}})}}
      {...props.settings?.B213}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B214") ? "red" : "white"}
      d="M645,170 L645,150A20,20 0 0,0 627.6794919243113,160 L645,170"
      transform="rotate(-150 645 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B214"}})}}
      {...props.settings?.B214}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B215") ? "red" : "white"}
      d="M645,170 L645,150A20,20 0 0,0 627.6794919243113,160 L645,170"
      transform="rotate(-210 645 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B215"}})}}
      {...props.settings?.B215}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B216") ? "red" : "white"}
      d="M645,170 L645,150A20,20 0 0,0 627.6794919243113,160 L645,170"
      transform="rotate(-270 645 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B216"}})}}
      {...props.settings?.B216}
    />
      <text 
        x={645}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >1</text>
      <>
      <text 
        x={597.5}
        y={146}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >Buccal</text>
      <text 
        x={597.5}
        y={194}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >Lingual</text>
      </>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B221") ? "red" : "white"}
      d="M685,170 L685,150A20,20 0 0,0 667.6794919243113,160 L685,170"
      transform="rotate(30 685 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B221"}})}}
      {...props.settings?.B221}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B222") ? "red" : "white"}
      d="M685,170 L685,150A20,20 0 0,0 667.6794919243113,160 L685,170"
      transform="rotate(-30 685 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B222"}})}}
      {...props.settings?.B222}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B223") ? "red" : "white"}
      d="M685,170 L685,150A20,20 0 0,0 667.6794919243113,160 L685,170"
      transform="rotate(-90 685 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B223"}})}}
      {...props.settings?.B223}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B224") ? "red" : "white"}
      d="M685,170 L685,150A20,20 0 0,0 667.6794919243113,160 L685,170"
      transform="rotate(-150 685 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B224"}})}}
      {...props.settings?.B224}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B225") ? "red" : "white"}
      d="M685,170 L685,150A20,20 0 0,0 667.6794919243113,160 L685,170"
      transform="rotate(-210 685 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B225"}})}}
      {...props.settings?.B225}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B226") ? "red" : "white"}
      d="M685,170 L685,150A20,20 0 0,0 667.6794919243113,160 L685,170"
      transform="rotate(-270 685 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B226"}})}}
      {...props.settings?.B226}
    />
      <text 
        x={685}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >2</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B231") ? "red" : "white"}
      d="M725,170 L725,150A20,20 0 0,0 707.6794919243113,160 L725,170"
      transform="rotate(30 725 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B231"}})}}
      {...props.settings?.B231}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B232") ? "red" : "white"}
      d="M725,170 L725,150A20,20 0 0,0 707.6794919243113,160 L725,170"
      transform="rotate(-30 725 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B232"}})}}
      {...props.settings?.B232}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B233") ? "red" : "white"}
      d="M725,170 L725,150A20,20 0 0,0 707.6794919243113,160 L725,170"
      transform="rotate(-90 725 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B233"}})}}
      {...props.settings?.B233}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B234") ? "red" : "white"}
      d="M725,170 L725,150A20,20 0 0,0 707.6794919243113,160 L725,170"
      transform="rotate(-150 725 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B234"}})}}
      {...props.settings?.B234}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B235") ? "red" : "white"}
      d="M725,170 L725,150A20,20 0 0,0 707.6794919243113,160 L725,170"
      transform="rotate(-210 725 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B235"}})}}
      {...props.settings?.B235}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B236") ? "red" : "white"}
      d="M725,170 L725,150A20,20 0 0,0 707.6794919243113,160 L725,170"
      transform="rotate(-270 725 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B236"}})}}
      {...props.settings?.B236}
    />
      <text 
        x={725}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >3</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B241") ? "red" : "white"}
      d="M765,170 L765,150A20,20 0 0,0 747.6794919243113,160 L765,170"
      transform="rotate(30 765 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B241"}})}}
      {...props.settings?.B241}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B242") ? "red" : "white"}
      d="M765,170 L765,150A20,20 0 0,0 747.6794919243113,160 L765,170"
      transform="rotate(-30 765 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B242"}})}}
      {...props.settings?.B242}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B243") ? "red" : "white"}
      d="M765,170 L765,150A20,20 0 0,0 747.6794919243113,160 L765,170"
      transform="rotate(-90 765 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B243"}})}}
      {...props.settings?.B243}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B244") ? "red" : "white"}
      d="M765,170 L765,150A20,20 0 0,0 747.6794919243113,160 L765,170"
      transform="rotate(-150 765 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B244"}})}}
      {...props.settings?.B244}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B245") ? "red" : "white"}
      d="M765,170 L765,150A20,20 0 0,0 747.6794919243113,160 L765,170"
      transform="rotate(-210 765 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B245"}})}}
      {...props.settings?.B245}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B246") ? "red" : "white"}
      d="M765,170 L765,150A20,20 0 0,0 747.6794919243113,160 L765,170"
      transform="rotate(-270 765 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B246"}})}}
      {...props.settings?.B246}
    />
      <text 
        x={765}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >4</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B251") ? "red" : "white"}
      d="M805,170 L805,150A20,20 0 0,0 787.6794919243113,160 L805,170"
      transform="rotate(30 805 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B251"}})}}
      {...props.settings?.B251}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B252") ? "red" : "white"}
      d="M805,170 L805,150A20,20 0 0,0 787.6794919243113,160 L805,170"
      transform="rotate(-30 805 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B252"}})}}
      {...props.settings?.B252}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B253") ? "red" : "white"}
      d="M805,170 L805,150A20,20 0 0,0 787.6794919243113,160 L805,170"
      transform="rotate(-90 805 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B253"}})}}
      {...props.settings?.B253}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B254") ? "red" : "white"}
      d="M805,170 L805,150A20,20 0 0,0 787.6794919243113,160 L805,170"
      transform="rotate(-150 805 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B254"}})}}
      {...props.settings?.B254}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B255") ? "red" : "white"}
      d="M805,170 L805,150A20,20 0 0,0 787.6794919243113,160 L805,170"
      transform="rotate(-210 805 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B255"}})}}
      {...props.settings?.B255}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B256") ? "red" : "white"}
      d="M805,170 L805,150A20,20 0 0,0 787.6794919243113,160 L805,170"
      transform="rotate(-270 805 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B256"}})}}
      {...props.settings?.B256}
    />
      <text 
        x={805}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >5</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B261") ? "red" : "white"}
      d="M845,170 L845,150A20,20 0 0,0 827.6794919243113,160 L845,170"
      transform="rotate(30 845 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B261"}})}}
      {...props.settings?.B261}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B262") ? "red" : "white"}
      d="M845,170 L845,150A20,20 0 0,0 827.6794919243113,160 L845,170"
      transform="rotate(-30 845 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B262"}})}}
      {...props.settings?.B262}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B263") ? "red" : "white"}
      d="M845,170 L845,150A20,20 0 0,0 827.6794919243113,160 L845,170"
      transform="rotate(-90 845 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B263"}})}}
      {...props.settings?.B263}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B264") ? "red" : "white"}
      d="M845,170 L845,150A20,20 0 0,0 827.6794919243113,160 L845,170"
      transform="rotate(-150 845 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B264"}})}}
      {...props.settings?.B264}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B265") ? "red" : "white"}
      d="M845,170 L845,150A20,20 0 0,0 827.6794919243113,160 L845,170"
      transform="rotate(-210 845 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B265"}})}}
      {...props.settings?.B265}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B266") ? "red" : "white"}
      d="M845,170 L845,150A20,20 0 0,0 827.6794919243113,160 L845,170"
      transform="rotate(-270 845 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B266"}})}}
      {...props.settings?.B266}
    />
      <text 
        x={845}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >6</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B271") ? "red" : "white"}
      d="M885,170 L885,150A20,20 0 0,0 867.6794919243113,160 L885,170"
      transform="rotate(30 885 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B271"}})}}
      {...props.settings?.B271}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B272") ? "red" : "white"}
      d="M885,170 L885,150A20,20 0 0,0 867.6794919243113,160 L885,170"
      transform="rotate(-30 885 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B272"}})}}
      {...props.settings?.B272}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B273") ? "red" : "white"}
      d="M885,170 L885,150A20,20 0 0,0 867.6794919243113,160 L885,170"
      transform="rotate(-90 885 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B273"}})}}
      {...props.settings?.B273}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B274") ? "red" : "white"}
      d="M885,170 L885,150A20,20 0 0,0 867.6794919243113,160 L885,170"
      transform="rotate(-150 885 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B274"}})}}
      {...props.settings?.B274}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B275") ? "red" : "white"}
      d="M885,170 L885,150A20,20 0 0,0 867.6794919243113,160 L885,170"
      transform="rotate(-210 885 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B275"}})}}
      {...props.settings?.B275}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B276") ? "red" : "white"}
      d="M885,170 L885,150A20,20 0 0,0 867.6794919243113,160 L885,170"
      transform="rotate(-270 885 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B276"}})}}
      {...props.settings?.B276}
    />
      <text 
        x={885}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >7</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B281") ? "red" : "white"}
      d="M925,170 L925,150A20,20 0 0,0 907.6794919243113,160 L925,170"
      transform="rotate(30 925 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B281"}})}}
      {...props.settings?.B281}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B282") ? "red" : "white"}
      d="M925,170 L925,150A20,20 0 0,0 907.6794919243113,160 L925,170"
      transform="rotate(-30 925 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B282"}})}}
      {...props.settings?.B282}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B283") ? "red" : "white"}
      d="M925,170 L925,150A20,20 0 0,0 907.6794919243113,160 L925,170"
      transform="rotate(-90 925 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B283"}})}}
      {...props.settings?.B283}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B284") ? "red" : "white"}
      d="M925,170 L925,150A20,20 0 0,0 907.6794919243113,160 L925,170"
      transform="rotate(-150 925 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B284"}})}}
      {...props.settings?.B284}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B285") ? "red" : "white"}
      d="M925,170 L925,150A20,20 0 0,0 907.6794919243113,160 L925,170"
      transform="rotate(-210 925 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B285"}})}}
      {...props.settings?.B285}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B286") ? "red" : "white"}
      d="M925,170 L925,150A20,20 0 0,0 907.6794919243113,160 L925,170"
      transform="rotate(-270 925 170)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B286"}})}}
      {...props.settings?.B286}
    />
      <text 
        x={925}
        y={205}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >8</text>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B311") ? "red" : "white"}
      d="M645,240 L645,220A20,20 0 0,0 627.6794919243113,230 L645,240"
      transform="rotate(30 645 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B311"}})}}
      {...props.settings?.B311}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B312") ? "red" : "white"}
      d="M645,240 L645,220A20,20 0 0,0 627.6794919243113,230 L645,240"
      transform="rotate(-30 645 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B312"}})}}
      {...props.settings?.B312}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B313") ? "red" : "white"}
      d="M645,240 L645,220A20,20 0 0,0 627.6794919243113,230 L645,240"
      transform="rotate(-90 645 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B313"}})}}
      {...props.settings?.B313}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B314") ? "red" : "white"}
      d="M645,240 L645,220A20,20 0 0,0 627.6794919243113,230 L645,240"
      transform="rotate(-150 645 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B314"}})}}
      {...props.settings?.B314}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B315") ? "red" : "white"}
      d="M645,240 L645,220A20,20 0 0,0 627.6794919243113,230 L645,240"
      transform="rotate(-210 645 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B315"}})}}
      {...props.settings?.B315}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B316") ? "red" : "white"}
      d="M645,240 L645,220A20,20 0 0,0 627.6794919243113,230 L645,240"
      transform="rotate(-270 645 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B316"}})}}
      {...props.settings?.B316}
    /><>
      <text 
        x={597.5}
        y={216}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >Lingual</text>
      <text 
        x={597.5}
        y={264}
        textAnchor="middle" 
        stroke="#FFFFFF" 
        strokeWidth="0.1px" 
        dy=".3em"
        fill="black" >Buccal</text>
      </>
      
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B321") ? "red" : "white"}
      d="M685,240 L685,220A20,20 0 0,0 667.6794919243113,230 L685,240"
      transform="rotate(30 685 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B321"}})}}
      {...props.settings?.B321}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B322") ? "red" : "white"}
      d="M685,240 L685,220A20,20 0 0,0 667.6794919243113,230 L685,240"
      transform="rotate(-30 685 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B322"}})}}
      {...props.settings?.B322}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B323") ? "red" : "white"}
      d="M685,240 L685,220A20,20 0 0,0 667.6794919243113,230 L685,240"
      transform="rotate(-90 685 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B323"}})}}
      {...props.settings?.B323}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B324") ? "red" : "white"}
      d="M685,240 L685,220A20,20 0 0,0 667.6794919243113,230 L685,240"
      transform="rotate(-150 685 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B324"}})}}
      {...props.settings?.B324}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B325") ? "red" : "white"}
      d="M685,240 L685,220A20,20 0 0,0 667.6794919243113,230 L685,240"
      transform="rotate(-210 685 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B325"}})}}
      {...props.settings?.B325}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B326") ? "red" : "white"}
      d="M685,240 L685,220A20,20 0 0,0 667.6794919243113,230 L685,240"
      transform="rotate(-270 685 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B326"}})}}
      {...props.settings?.B326}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B331") ? "red" : "white"}
      d="M725,240 L725,220A20,20 0 0,0 707.6794919243113,230 L725,240"
      transform="rotate(30 725 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B331"}})}}
      {...props.settings?.B331}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B332") ? "red" : "white"}
      d="M725,240 L725,220A20,20 0 0,0 707.6794919243113,230 L725,240"
      transform="rotate(-30 725 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B332"}})}}
      {...props.settings?.B332}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B333") ? "red" : "white"}
      d="M725,240 L725,220A20,20 0 0,0 707.6794919243113,230 L725,240"
      transform="rotate(-90 725 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B333"}})}}
      {...props.settings?.B333}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B334") ? "red" : "white"}
      d="M725,240 L725,220A20,20 0 0,0 707.6794919243113,230 L725,240"
      transform="rotate(-150 725 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B334"}})}}
      {...props.settings?.B334}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B335") ? "red" : "white"}
      d="M725,240 L725,220A20,20 0 0,0 707.6794919243113,230 L725,240"
      transform="rotate(-210 725 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B335"}})}}
      {...props.settings?.B335}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B336") ? "red" : "white"}
      d="M725,240 L725,220A20,20 0 0,0 707.6794919243113,230 L725,240"
      transform="rotate(-270 725 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B336"}})}}
      {...props.settings?.B336}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B341") ? "red" : "white"}
      d="M765,240 L765,220A20,20 0 0,0 747.6794919243113,230 L765,240"
      transform="rotate(30 765 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B341"}})}}
      {...props.settings?.B341}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B342") ? "red" : "white"}
      d="M765,240 L765,220A20,20 0 0,0 747.6794919243113,230 L765,240"
      transform="rotate(-30 765 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B342"}})}}
      {...props.settings?.B342}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B343") ? "red" : "white"}
      d="M765,240 L765,220A20,20 0 0,0 747.6794919243113,230 L765,240"
      transform="rotate(-90 765 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B343"}})}}
      {...props.settings?.B343}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B344") ? "red" : "white"}
      d="M765,240 L765,220A20,20 0 0,0 747.6794919243113,230 L765,240"
      transform="rotate(-150 765 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B344"}})}}
      {...props.settings?.B344}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B345") ? "red" : "white"}
      d="M765,240 L765,220A20,20 0 0,0 747.6794919243113,230 L765,240"
      transform="rotate(-210 765 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B345"}})}}
      {...props.settings?.B345}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B346") ? "red" : "white"}
      d="M765,240 L765,220A20,20 0 0,0 747.6794919243113,230 L765,240"
      transform="rotate(-270 765 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B346"}})}}
      {...props.settings?.B346}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B351") ? "red" : "white"}
      d="M805,240 L805,220A20,20 0 0,0 787.6794919243113,230 L805,240"
      transform="rotate(30 805 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B351"}})}}
      {...props.settings?.B351}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B352") ? "red" : "white"}
      d="M805,240 L805,220A20,20 0 0,0 787.6794919243113,230 L805,240"
      transform="rotate(-30 805 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B352"}})}}
      {...props.settings?.B352}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B353") ? "red" : "white"}
      d="M805,240 L805,220A20,20 0 0,0 787.6794919243113,230 L805,240"
      transform="rotate(-90 805 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B353"}})}}
      {...props.settings?.B353}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B354") ? "red" : "white"}
      d="M805,240 L805,220A20,20 0 0,0 787.6794919243113,230 L805,240"
      transform="rotate(-150 805 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B354"}})}}
      {...props.settings?.B354}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B355") ? "red" : "white"}
      d="M805,240 L805,220A20,20 0 0,0 787.6794919243113,230 L805,240"
      transform="rotate(-210 805 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B355"}})}}
      {...props.settings?.B355}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B356") ? "red" : "white"}
      d="M805,240 L805,220A20,20 0 0,0 787.6794919243113,230 L805,240"
      transform="rotate(-270 805 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B356"}})}}
      {...props.settings?.B356}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B361") ? "red" : "white"}
      d="M845,240 L845,220A20,20 0 0,0 827.6794919243113,230 L845,240"
      transform="rotate(30 845 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B361"}})}}
      {...props.settings?.B361}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B362") ? "red" : "white"}
      d="M845,240 L845,220A20,20 0 0,0 827.6794919243113,230 L845,240"
      transform="rotate(-30 845 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B362"}})}}
      {...props.settings?.B362}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B363") ? "red" : "white"}
      d="M845,240 L845,220A20,20 0 0,0 827.6794919243113,230 L845,240"
      transform="rotate(-90 845 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B363"}})}}
      {...props.settings?.B363}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B364") ? "red" : "white"}
      d="M845,240 L845,220A20,20 0 0,0 827.6794919243113,230 L845,240"
      transform="rotate(-150 845 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B364"}})}}
      {...props.settings?.B364}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B365") ? "red" : "white"}
      d="M845,240 L845,220A20,20 0 0,0 827.6794919243113,230 L845,240"
      transform="rotate(-210 845 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B365"}})}}
      {...props.settings?.B365}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B366") ? "red" : "white"}
      d="M845,240 L845,220A20,20 0 0,0 827.6794919243113,230 L845,240"
      transform="rotate(-270 845 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B366"}})}}
      {...props.settings?.B366}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B371") ? "red" : "white"}
      d="M885,240 L885,220A20,20 0 0,0 867.6794919243113,230 L885,240"
      transform="rotate(30 885 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B371"}})}}
      {...props.settings?.B371}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B372") ? "red" : "white"}
      d="M885,240 L885,220A20,20 0 0,0 867.6794919243113,230 L885,240"
      transform="rotate(-30 885 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B372"}})}}
      {...props.settings?.B372}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B373") ? "red" : "white"}
      d="M885,240 L885,220A20,20 0 0,0 867.6794919243113,230 L885,240"
      transform="rotate(-90 885 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B373"}})}}
      {...props.settings?.B373}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B374") ? "red" : "white"}
      d="M885,240 L885,220A20,20 0 0,0 867.6794919243113,230 L885,240"
      transform="rotate(-150 885 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B374"}})}}
      {...props.settings?.B374}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B375") ? "red" : "white"}
      d="M885,240 L885,220A20,20 0 0,0 867.6794919243113,230 L885,240"
      transform="rotate(-210 885 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B375"}})}}
      {...props.settings?.B375}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B376") ? "red" : "white"}
      d="M885,240 L885,220A20,20 0 0,0 867.6794919243113,230 L885,240"
      transform="rotate(-270 885 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B376"}})}}
      {...props.settings?.B376}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B381") ? "red" : "white"}
      d="M925,240 L925,220A20,20 0 0,0 907.6794919243113,230 L925,240"
      transform="rotate(30 925 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B381"}})}}
      {...props.settings?.B381}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B382") ? "red" : "white"}
      d="M925,240 L925,220A20,20 0 0,0 907.6794919243113,230 L925,240"
      transform="rotate(-30 925 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B382"}})}}
      {...props.settings?.B382}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B383") ? "red" : "white"}
      d="M925,240 L925,220A20,20 0 0,0 907.6794919243113,230 L925,240"
      transform="rotate(-90 925 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B383"}})}}
      {...props.settings?.B383}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B384") ? "red" : "white"}
      d="M925,240 L925,220A20,20 0 0,0 907.6794919243113,230 L925,240"
      transform="rotate(-150 925 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B384"}})}}
      {...props.settings?.B384}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B385") ? "red" : "white"}
      d="M925,240 L925,220A20,20 0 0,0 907.6794919243113,230 L925,240"
      transform="rotate(-210 925 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B385"}})}}
      {...props.settings?.B385}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B386") ? "red" : "white"}
      d="M925,240 L925,220A20,20 0 0,0 907.6794919243113,230 L925,240"
      transform="rotate(-270 925 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B386"}})}}
      {...props.settings?.B386}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B411") ? "red" : "white"}
      d="M550,240 L550,220A20,20 0 0,0 532.6794919243113,230 L550,240"
      transform="rotate(30 550 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B411"}})}}
      {...props.settings?.B411}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B412") ? "red" : "white"}
      d="M550,240 L550,220A20,20 0 0,0 532.6794919243113,230 L550,240"
      transform="rotate(-30 550 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B412"}})}}
      {...props.settings?.B412}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B413") ? "red" : "white"}
      d="M550,240 L550,220A20,20 0 0,0 532.6794919243113,230 L550,240"
      transform="rotate(-90 550 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B413"}})}}
      {...props.settings?.B413}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B414") ? "red" : "white"}
      d="M550,240 L550,220A20,20 0 0,0 532.6794919243113,230 L550,240"
      transform="rotate(-150 550 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B414"}})}}
      {...props.settings?.B414}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B415") ? "red" : "white"}
      d="M550,240 L550,220A20,20 0 0,0 532.6794919243113,230 L550,240"
      transform="rotate(-210 550 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B415"}})}}
      {...props.settings?.B415}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B416") ? "red" : "white"}
      d="M550,240 L550,220A20,20 0 0,0 532.6794919243113,230 L550,240"
      transform="rotate(-270 550 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B416"}})}}
      {...props.settings?.B416}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B421") ? "red" : "white"}
      d="M510,240 L510,220A20,20 0 0,0 492.6794919243112,230 L510,240"
      transform="rotate(30 510 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B421"}})}}
      {...props.settings?.B421}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B422") ? "red" : "white"}
      d="M510,240 L510,220A20,20 0 0,0 492.6794919243112,230 L510,240"
      transform="rotate(-30 510 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B422"}})}}
      {...props.settings?.B422}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B423") ? "red" : "white"}
      d="M510,240 L510,220A20,20 0 0,0 492.6794919243112,230 L510,240"
      transform="rotate(-90 510 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B423"}})}}
      {...props.settings?.B423}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B424") ? "red" : "white"}
      d="M510,240 L510,220A20,20 0 0,0 492.6794919243112,230 L510,240"
      transform="rotate(-150 510 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B424"}})}}
      {...props.settings?.B424}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B425") ? "red" : "white"}
      d="M510,240 L510,220A20,20 0 0,0 492.6794919243112,230 L510,240"
      transform="rotate(-210 510 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B425"}})}}
      {...props.settings?.B425}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B426") ? "red" : "white"}
      d="M510,240 L510,220A20,20 0 0,0 492.6794919243112,230 L510,240"
      transform="rotate(-270 510 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B426"}})}}
      {...props.settings?.B426}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B431") ? "red" : "white"}
      d="M470,240 L470,220A20,20 0 0,0 452.6794919243112,230 L470,240"
      transform="rotate(30 470 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B431"}})}}
      {...props.settings?.B431}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B432") ? "red" : "white"}
      d="M470,240 L470,220A20,20 0 0,0 452.6794919243112,230 L470,240"
      transform="rotate(-30 470 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B432"}})}}
      {...props.settings?.B432}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B433") ? "red" : "white"}
      d="M470,240 L470,220A20,20 0 0,0 452.6794919243112,230 L470,240"
      transform="rotate(-90 470 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B433"}})}}
      {...props.settings?.B433}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B434") ? "red" : "white"}
      d="M470,240 L470,220A20,20 0 0,0 452.6794919243112,230 L470,240"
      transform="rotate(-150 470 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B434"}})}}
      {...props.settings?.B434}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B435") ? "red" : "white"}
      d="M470,240 L470,220A20,20 0 0,0 452.6794919243112,230 L470,240"
      transform="rotate(-210 470 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B435"}})}}
      {...props.settings?.B435}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B436") ? "red" : "white"}
      d="M470,240 L470,220A20,20 0 0,0 452.6794919243112,230 L470,240"
      transform="rotate(-270 470 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B436"}})}}
      {...props.settings?.B436}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B441") ? "red" : "white"}
      d="M430,240 L430,220A20,20 0 0,0 412.6794919243112,230 L430,240"
      transform="rotate(30 430 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B441"}})}}
      {...props.settings?.B441}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B442") ? "red" : "white"}
      d="M430,240 L430,220A20,20 0 0,0 412.6794919243112,230 L430,240"
      transform="rotate(-30 430 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B442"}})}}
      {...props.settings?.B442}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B443") ? "red" : "white"}
      d="M430,240 L430,220A20,20 0 0,0 412.6794919243112,230 L430,240"
      transform="rotate(-90 430 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B443"}})}}
      {...props.settings?.B443}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B444") ? "red" : "white"}
      d="M430,240 L430,220A20,20 0 0,0 412.6794919243112,230 L430,240"
      transform="rotate(-150 430 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B444"}})}}
      {...props.settings?.B444}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B445") ? "red" : "white"}
      d="M430,240 L430,220A20,20 0 0,0 412.6794919243112,230 L430,240"
      transform="rotate(-210 430 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B445"}})}}
      {...props.settings?.B445}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B446") ? "red" : "white"}
      d="M430,240 L430,220A20,20 0 0,0 412.6794919243112,230 L430,240"
      transform="rotate(-270 430 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B446"}})}}
      {...props.settings?.B446}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B451") ? "red" : "white"}
      d="M390,240 L390,220A20,20 0 0,0 372.6794919243112,230 L390,240"
      transform="rotate(30 390 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B451"}})}}
      {...props.settings?.B451}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B452") ? "red" : "white"}
      d="M390,240 L390,220A20,20 0 0,0 372.6794919243112,230 L390,240"
      transform="rotate(-30 390 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B452"}})}}
      {...props.settings?.B452}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B453") ? "red" : "white"}
      d="M390,240 L390,220A20,20 0 0,0 372.6794919243112,230 L390,240"
      transform="rotate(-90 390 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B453"}})}}
      {...props.settings?.B453}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B454") ? "red" : "white"}
      d="M390,240 L390,220A20,20 0 0,0 372.6794919243112,230 L390,240"
      transform="rotate(-150 390 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B454"}})}}
      {...props.settings?.B454}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B455") ? "red" : "white"}
      d="M390,240 L390,220A20,20 0 0,0 372.6794919243112,230 L390,240"
      transform="rotate(-210 390 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B455"}})}}
      {...props.settings?.B455}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B456") ? "red" : "white"}
      d="M390,240 L390,220A20,20 0 0,0 372.6794919243112,230 L390,240"
      transform="rotate(-270 390 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B456"}})}}
      {...props.settings?.B456}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B461") ? "red" : "white"}
      d="M350,240 L350,220A20,20 0 0,0 332.6794919243112,230 L350,240"
      transform="rotate(30 350 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B461"}})}}
      {...props.settings?.B461}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B462") ? "red" : "white"}
      d="M350,240 L350,220A20,20 0 0,0 332.6794919243112,230 L350,240"
      transform="rotate(-30 350 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B462"}})}}
      {...props.settings?.B462}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B463") ? "red" : "white"}
      d="M350,240 L350,220A20,20 0 0,0 332.6794919243112,230 L350,240"
      transform="rotate(-90 350 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B463"}})}}
      {...props.settings?.B463}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B464") ? "red" : "white"}
      d="M350,240 L350,220A20,20 0 0,0 332.6794919243112,230 L350,240"
      transform="rotate(-150 350 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B464"}})}}
      {...props.settings?.B464}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B465") ? "red" : "white"}
      d="M350,240 L350,220A20,20 0 0,0 332.6794919243112,230 L350,240"
      transform="rotate(-210 350 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B465"}})}}
      {...props.settings?.B465}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B466") ? "red" : "white"}
      d="M350,240 L350,220A20,20 0 0,0 332.6794919243112,230 L350,240"
      transform="rotate(-270 350 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B466"}})}}
      {...props.settings?.B466}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B471") ? "red" : "white"}
      d="M310,240 L310,220A20,20 0 0,0 292.6794919243112,230 L310,240"
      transform="rotate(30 310 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B471"}})}}
      {...props.settings?.B471}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B472") ? "red" : "white"}
      d="M310,240 L310,220A20,20 0 0,0 292.6794919243112,230 L310,240"
      transform="rotate(-30 310 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B472"}})}}
      {...props.settings?.B472}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B473") ? "red" : "white"}
      d="M310,240 L310,220A20,20 0 0,0 292.6794919243112,230 L310,240"
      transform="rotate(-90 310 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B473"}})}}
      {...props.settings?.B473}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B474") ? "red" : "white"}
      d="M310,240 L310,220A20,20 0 0,0 292.6794919243112,230 L310,240"
      transform="rotate(-150 310 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B474"}})}}
      {...props.settings?.B474}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B475") ? "red" : "white"}
      d="M310,240 L310,220A20,20 0 0,0 292.6794919243112,230 L310,240"
      transform="rotate(-210 310 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B475"}})}}
      {...props.settings?.B475}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B476") ? "red" : "white"}
      d="M310,240 L310,220A20,20 0 0,0 292.6794919243112,230 L310,240"
      transform="rotate(-270 310 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B476"}})}}
      {...props.settings?.B476}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B481") ? "red" : "white"}
      d="M270,240 L270,220A20,20 0 0,0 252.67949192431124,230 L270,240"
      transform="rotate(30 270 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B481"}})}}
      {...props.settings?.B481}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B482") ? "red" : "white"}
      d="M270,240 L270,220A20,20 0 0,0 252.67949192431124,230 L270,240"
      transform="rotate(-30 270 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B482"}})}}
      {...props.settings?.B482}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B483") ? "red" : "white"}
      d="M270,240 L270,220A20,20 0 0,0 252.67949192431124,230 L270,240"
      transform="rotate(-90 270 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B483"}})}}
      {...props.settings?.B483}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B484") ? "red" : "white"}
      d="M270,240 L270,220A20,20 0 0,0 252.67949192431124,230 L270,240"
      transform="rotate(-150 270 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B484"}})}}
      {...props.settings?.B484}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B485") ? "red" : "white"}
      d="M270,240 L270,220A20,20 0 0,0 252.67949192431124,230 L270,240"
      transform="rotate(-210 270 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B485"}})}}
      {...props.settings?.B485}
    />
    <path
      stroke="black"
      fill={props.encounterInfo?.bleeding?.includes("B486") ? "red" : "white"}
      d="M270,240 L270,220A20,20 0 0,0 252.67949192431124,230 L270,240"
      transform="rotate(-270 270 240)"
      onClick={(e) => { props.onEvent({ message: "SetBleeding", params: { key: "B486"}})}}
      {...props.settings?.B486}
    />
  </svg>
  )
}
  
export default PlaqueRecordUX